import "./index.css";


function HeroSection(){

return(

<div className="hero">

<div className="hero-overlay">

<h1>Chaudhary Charan Singh Rajkiya Mahavidyalaya Chhaparauli</h1>

<p>
Providing quality education and empowering students for a better future
</p>

<div className="hero-buttons">

<a href="/admissions" className="btn-primary">
Admission Information
</a>

<a href="/notices" className="btn-secondary">
Latest Notices
</a>

</div>

</div>

</div>

);

}

export default HeroSection;